module.exports = __webpack_public_path__ + "static/img/food2.0505918.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/food2.png
// module id = QVCE
// module chunks = 0